import gql from "graphql-tag";

export const cancelInvite = gql`
  mutation CancelInvite(
    $input: CancelInviteInput!) {
    cancelInvite(input: $input) {
      project {
        id
        invites {
            author {
              id
              name
              profilePictureUrl
            }
            invitedAt
            role
            status
            code
            email
        }
      }
    }
  }
`;

export const cancelInviteOptions = {
  name: "cancelInvite",
};
